// extracted by mini-css-extract-plugin
module.exports = {"myWidgetHeader":"MyWidgetHeader_myWidgetHeader__2dmot"};